export const GET_PDFINFO_STARTED = "GET_PDFINFO_STARTED";
export const GET_PDFINFO_SUCESS = "GET_PDFINFO_SUCESS";
export const GET_PDFINFO_FAILED = "GET_PDFINFO_FAILED";
export interface ITestPdfViewer {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    MODEMInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    permission_id: number;
    isLoading: boolean;
    error: string;
}
export const getPdfView = (companyId) => {
    // alert("newid");
     return {
         type: GET_PDFINFO_STARTED ,
         payload: 'Value',
         input:companyId
     };
 };